var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivisor1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 859,
    height: 64,
    viewBox: "0 0 859 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.0318 34C82.0318 50.5685 95.4633 64 112.032 64H859V0H0H52.0318C68.6004 0 82.0318 13.4315 82.0318 30V34Z",
    fill: "#FAF4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivisor1);
export default __webpack_public_path__ + "static/media/Divisor1.4b671bda452de3092606d8b54c1491b0.svg";
export { ForwardRef as ReactComponent };